import { Image, styled } from '@teko/ds-desktop';
import { PhoneCallColored } from '@teko/ds-icon';
import React from 'react';

interface IPhoneIconProps {
  consultantPhone: string;
  customImage?: string;
  position?: string;
  right?: number;
  bottom?: number;
}

export const PhoneIcon: React.FC<IPhoneIconProps> = (props) => {
  const { consultantPhone, customImage, ...rest } = props;
  return (
    <FloatIconWrapper href={`tel:${consultantPhone}`} {...rest}>
      {!!customImage?.length ? (
        <Image src={customImage} />
      ) : (
        <PhoneCallColored size={44} />
      )}
    </FloatIconWrapper>
  );
};

const FloatIconWrapper = styled.a(
  ({
    position,
    right,
    bottom,
  }: Pick<IPhoneIconProps, 'position' | 'right' | 'bottom'>) => `
  z-index: 1030;
  position: ${!!position ? position : ''};
  right: ${!!right ? `${right}rem` : ''};
  bottom: ${!!bottom ? `${bottom}rem` : ''};
  cursor: pointer;
  @media print {
    display: none;
  }
`,
);
